export enum PageOptionGroup {
    CREATE = 1,
    DETAIL = 2,
    EDIT = 3,
}